// YouTube URL parsing helpers
export function parseYouTubeId(url = "") {
    if (!url) return null;
    const patterns = [
        /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/shorts\/)([A-Za-z0-9_-]{6,})/,
    ];
    for (const p of patterns) {
        const m = url.match(p);
        if (m) return m[1];
    }
    return null;
}

export function isShorts(url = "") {
    return /shorts\//.test(url);
}

export function ytEmbed(url, opts = {}) {
    const id = parseYouTubeId(url);
    if (!id) return null;
    const params = new URLSearchParams({
        rel: "0",
        modestbranding: "1",
        ...(opts.autoplay ? { autoplay: "1" } : {}),
        ...(opts.mute ? { mute: "1" } : {}),
        ...(opts.controls === false ? { controls: "0" } : {}),
        playsinline: "1",
    });
    return `https://www.youtube.com/embed/${id}?${params.toString()}`;
}

export function ytThumb(url) {
    const id = parseYouTubeId(url);
    return id ? `https://i.ytimg.com/vi/${id}/hqdefault.jpg` : null;
}

export function isMp4(url = "") {
    return /\.(mp4|webm|mov)(\?|$)/i.test(url);
}
